module.exports = __webpack_public_path__ + "img/lock-checkmark-square.4ae6f8a3.svg";